// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input__Input__1VROp","Label":"Input__Label__1tOSX","InputElement":"Input__InputElement__3TB0k","Invalid":"Input__Invalid__38X2d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.css
// module id = 135
// module chunks = 2